import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function getBudgetPlanProfile(id) {
  return getApi({
    endpoint: `api/budget-plan/${id}/`,
    params: { with_invoices: false },
  })
}

export function getBudgetPlanInvoices({ id, params }) {
  return getApi({ endpoint: `api/budget-plan/${id}/invoices/`, params })
}

export function createBudgetPlanProfile(data) {
  return postApi({ data, endpoint: 'api/budget-plan/' })
}

export function updateBudgetPlanProfile({ data, id }) {
  return patchApi({ data, endpoint: `api/budget-plan/${id}/` })
}

export function getInvoiceFields(requestId) {
  return getApi({ endpoint: `api/budget-plan/invoice-fields/${requestId}/` })
}

export function createInvoice(data) {
  return postApi({ data, endpoint: 'api/budget-plan/invoice/' })
}

export function updateInvoice({ data, id }) {
  return patchApi({ data, endpoint: `api/budget-plan/invoice/${id}/` })
}

export function deleteInvoice(id) {
  return deleteApi({ endpoint: `api/budget-plan/invoice/${id}/` })
}

export function deleteInvoices(data) {
  return deleteApi({ data, endpoint: 'api/budget-plan/invoice/batch-delete/' })
}

export function createBudgetPlanReport(data) {
  return postApi({ data, endpoint: 'api/budget-plan/report/' })
}

export function getDomondaSettings() {
  return getApi({ endpoint: 'api/budget-plan/domonda/settings/' })
}

export function updateDomondaSettings(data) {
  return postApi({ data, endpoint: 'api/budget-plan/domonda/settings/' })
}

export function parseDomondaDocument(data) {
  return postApi({ data, endpoint: 'api/budget-plan/domonda/parse/' })
}

export function getDomondaResult(eventId) {
  return getApi({ endpoint: `api/budget-plan/domonda/result/${eventId}/` })
}

export function getSuppliers(params) {
  return getApi({ endpoint: 'api/budget-plan/suppliers/', params })
}
